<div class="action-btn">
        <button class="margin-right" (click)="showModal = true" nz-button nzType="default" [disabled]="!authService.webAdm">Reset</button>
        <button [disabled]="validateCatalogName()" (click)="saveCatalog()"  nz-button nzType="primary" [disabled]="!authService.webAdm">Save</button>
    </div>
<div class="add-catalog-title">
    <h6>Catalog Attributes</h6>
</div>
@if(!loading){
<ng-container>
<form [formGroup]="addEditCatalogForm">
    <div class="form-container row g-3">
        <div class="col-md-6 mb-2 position-relative" #catDesc>
            <label class="form-label"> Catalog Name<span class="text-danger">*</span></label>
            <input maxlength="100" type="text" (blur)="trimCatalogDesc()" formControlName="catalogDesc" class="form-control" placeholder="Enter Catalog Name" required>
              <span class="text-danger" *ngIf="(addEditCatalogForm.get('catalogDesc')?.errors?.required && !addEditCatalogForm.get('catalogDesc')?.value &&  (addEditCatalogForm.get('catalogDesc')?.touched) ||
                        (addEditCatalogForm.get('catalogDesc')?.errors?.required) && invalidForm)">
                        Catalog Name is required.
                    </span>
                    <span class="text-danger" *ngIf="catalogData && catalogData.length > 0 && validateCatalogName()">
                        Catalog Name already exists.
                    </span>
        </div>
        <div class="col-md-6 mb-2 d-flex flex-column">
            <label class="form-label"> Copy From Catalog</label>
            <nz-select [nzShowSearch]="true" formControlName="copyCatId" nzAllowClear="true" nzPlaceHolder="Select A Catalog" nzSize="default" style="height: 35px !important;">
                @for (option of catalogData; track option) {
                <nz-option [nzLabel]="option.catalogName" [nzValue]="option.catalogId"></nz-option>
                }
            </nz-select>
        </div>

    </div>
    <div class="add-catalog-title">
        <h6>Configuration Options</h6>
    </div>
    <div class="form-container row g-3">
        <div class="col-md-6">
            <div class="form-check">
                <input class="form-check-input" formControlName="allowCloseOut" type="checkbox">
                <label class="form-check-label"> Allow Closeout Lots</label>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-check">
                <input class="form-check-input" formControlName="checkCloseOut" type="checkbox">
                <label class="form-check-label">Remove Closeout Lots Automatically</label>
            </div>
        </div>
                <div class="col-md-6">
            <label class="form-label"> Minimum Inventory for Removal</label>
            <input maxlength="7" oninput="if (this.value.length > 7) this.value = this.value.slice(0, 7);" type="number" formControlName="minimumInventory"  class="form-control" placeholder="Enter quantity" required>
        </div>
        <div class="col-md-6">
            <label class="form-label"> Email Address for Notification</label>
            <div class="input-group">
                <input type="text" formControlName="emailAddress" maxlength="200" class="form-control" placeholder="Enter email" required>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-check">
                <input class="form-check-input" formControlName="notifyOptionalCustomize" type="checkbox">
                <label class="form-check-label">Allow Pop-up Notification</label>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-check">
                <input class="form-check-input" formControlName="allowAddLettering" type="checkbox">
                <label class="form-check-label">Allow Additional Lettering</label>
            </div>
        </div>
        
        <div class="col-md-6">
            <div class="form-check">
                <input class="form-check-input" formControlName="allowKeywordSearch" type="checkbox">
                <label class="form-check-label"> Allow Keyword Search</label>
            </div>
        </div>
         <div class="col-md-6">
                <div class="form-check">
                    <input formControlName="multiLotUpdate" class="form-check-input" type="checkbox">
                    <label class="form-check-label"> Enable multi-category Product update</label>
                </div>
            </div>



    </div>
    <div class="form-container py-0 mb-4">
        <div class="ship-title">
            <h6>Ship-To Address Pop-up</h6>
        </div>
        <nz-radio-group formControlName="shipToAddrPopUp">
            <label nz-radio nzValue="0">None</label>
            <label nz-radio nzValue="1">Verify ship-to address, change allowed</label>
            <label nz-radio nzValue="2">Verify ship-to address, no change allowed</label>
            <label nz-radio nzValue="3">
                Verify ship-to address, add text 
            </label>
        </nz-radio-group>
        <div class="mt-3">
            <textarea maxlength="250" formControlName="checkoutMsg" type="text" class="form-control"></textarea>
        </div>
    </div>
</form>
</ng-container>
}
@if(loading){
<app-spinner></app-spinner>
}
<app-confirm-popup *ngIf="showModal" [title]="'Reset Confirmation'" [message]="'Are your sure to revert the changes?'"
  [confirmText]="'Confirm'" [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="resetForm()"
  (cancel)="showModal =false"></app-confirm-popup>